module.exports = __webpack_public_path__ + "static/media/E1.b113ba89.png";